import Base from '../../js/_base';
import TableAccordion from '../../components/table-accordion/_table_accordion';
import {mimicLoading} from '../../js/_utlis';

let $document;

export default class DevicePairing extends Base {
    tableHeadings;
    tableAccordion;
    selectedDevices;

    get selectors() {
        return {
            devicesWrapper: '.device-pairing__devices',
            table: '.device-pairing__devices__table',
            tableAccordionWrapper: '.accordion-table',
            noResult: '.device-pairing__no-result',
            actions: '.device-pairing__actions',
            tableHeadings: '.headings',
            spinner: '.spinner-border__wrapper',
            unpairButton: '#unpair-selected',
            unpairAllButton: '#unpair-all',
            confirmUnpair: '#confirm-unpair-devices',
            checkboxes: '[name="deviceId"]',
            selectedList: '.device-pairing__selected-list',
        };
    }

    get classList() {
        return {
            hide: 'd-none',
        };
    }

    get elements() {
        return {
            devicesWrapper: null,
            table: null,
            noResult: null,
            actions: null,
            tableAccordionWrapper: null,
            tableHeadings: null,
            unpairButton: null,
            unpairAllButton: null,
            confirmUnpair: null,
            checkboxes: null,
            selectedList: null,
        };
    }

    get params() {
        return `widgetId=${this.widgetId}&pbContext=${this.pbContext}`;
    }

    get localURI() {
        return 'ajax/list-of-devices.html';
    }

    get url() {
        return `/pb/widgets/ux3/DevicePairingController/pairedDevices?${this.params}`;
    }

    get selectedDevicesParam() {
        return `devices=${JSON.stringify(this.selectedDevices)}`;
    }

    get unpairURL() {
        return `/pb/widgets/ux3/DevicePairingController/unpairSelected?${this.params}&${this.selectedDevicesParam}`;
    }

    get loader() {
        return `
<div class="d-flex ${this._selectors.spinner.split('.').pop()} justify-content-center align-items-center">
    <div class="spinner-border text-gray" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>`;
    }

    set data(data) {
        const {id, serviceName, personEmail} = JSON.parse(data);
        this.widgetId = id;
        this.service = serviceName;
        this.email = personEmail;
        this.pbContext = encodeURI($("[name='pbContext']").attr('content'));
    }

    constructor(wrapper) {
        super();
        this.wrapper = wrapper;
        this.data = wrapper.dataset.info;
        $document = $(document);
        this.initialize();
        this.addEventListeners();
    }

    initialize() {
        super.initialize();
        this.setElements();
        this.initTableAccordion();
        /**
         * send local URI
         */
        // this.sendAjax(this.localURI, 'setTableData', 'devicesWrapper');
        this.sendAjax(this.url, 'setTableData', 'devicesWrapper');
    }

    initTableAccordion() {
        this.tableAccordion = new TableAccordion($document, this._elements.tableAccordionWrapper);
    }

    setElements() {
        Object.keys(this._elements).forEach(item => {
            if (item === 'checkboxes') {
                this._elements[item] = this.wrapper.querySelectorAll(this._selectors[item]);
            } else {
                this._elements[item] = this.wrapper.querySelector(this._selectors[item]);
            }
        });
        /**
         * get the html only from this element
         */
        this._elements.tableHeadings = this._elements.tableHeadings.outerHTML;
    }

    addEventListeners() {
        this._elements.unpairAllButton?.addEventListener('click', this.onShowModal.bind(this, true));
        this._elements.unpairButton?.addEventListener('click', this.onShowModal.bind(this, false));
        this._elements.confirmUnpair?.addEventListener('click', this.onUnpair.bind(this));
    }

    isEmpty(html) {
        return html.indexOf('table-data-row') < 0;
    }

    setLoading(loading, wrapper) {
        if (!loading) {
            this.wrapper.querySelector(this._selectors.spinner)?.remove();
            return;
        }
        const spinner = this.loader;
        wrapper?.insertAdjacentHTML('afterend', spinner);
    }

    onShowModal(all) {
        const items = this._elements.checkboxes.filter(item => all || item.checked);
        this.selectedDevices = items.map(item => item.id);
        this._elements.selectedList.innerHTML = items.map(item => this.getSelectedListItem(item)).join('');
    }

    getSelectedListItem(item) {
        return `<li class="border-bottom pb-3 mb-3">${item.value}</li>`;
    }

    onCheckboxChange() {
        const isEnabled = this._elements.checkboxes.find(item => item.checked);
        if (isEnabled) {
            this._elements.unpairButton.removeAttribute('disabled');
        } else {
            this._elements.unpairButton.setAttribute('disabled', 'true');
        }
    }

    setCheckboxes() {
        this._elements.checkboxes = Array.prototype.slice.call(
            this.wrapper.querySelectorAll(this._selectors.checkboxes)
        );
        this._elements.checkboxes.forEach(item => {
            item.addEventListener('change', this.onCheckboxChange.bind(this));
        });
    }

    setTableData(html) {
        this._elements.tableAccordionWrapper.innerHTML = `${this._elements.tableHeadings} ${html}`;
        this.tableAccordion.setElements();
        this.tableAccordion.currentViewPort();
        this._elements.unpairButton.setAttribute('disabled', true);

        const isEmpty = this.isEmpty(html);
        if (!isEmpty) {
            this.setCheckboxes();
        }
        this._elements.table.classList.toggle(this._classList.hide, isEmpty);
        this._elements.actions.classList.toggle(this._classList.hide, isEmpty);
        this._elements.noResult.classList.toggle(this._classList.hide, !isEmpty);
    }

    async sendAjax(url, handler, wrapper) {
        this.setLoading(true, this._elements[wrapper]);
        /**
         * mimic ajax loading time, just to show the loading spinner
         */
        await mimicLoading();
        try {
            const response = await fetch(url);
            if (response.status !== 200) {
                this[handler]('');
            } else {
                const html = await response.text();
                this[handler](html);
            }

            this.setLoading(false, this._elements[wrapper]);
        } catch (e) {
            this.setLoading(false, this._elements[wrapper]);
        }
    }

    async onUnpair() {
        this._elements.table.classList.add(this._classList.hide);
        this._elements.actions.classList.add(this._classList.hide);
        await this.sendAjax(this.unpairURL, 'setTableData', 'devicesWrapper');
        this.selectedDevices = [];
    }
}
